/* MONK CUSTOM — Jam Loop 錄影正式介面（階段 3，2026-09-15）
   畫面依 UI 模擬 v3（jam-record-mvp/mockup/jam-record-ui.html）：錄影設定 → 精準校準 → 錄影中 → 錄後預覽。
   邏輯全在 assets/jam-rec.js（window.MCJamRec），這支只管畫面。決策與實測的事實來源＝記憶檔 project_monkcustom_musician_tools_2026q3.md。

   工具頁硬規則：全程 px（主題根字級 10px）、DM Sans 不另載字型、translate="no"、Craft Gold ≤8%。
   ⚠️ 浮層掛在 body 底下，主題 token 只掛在 .mc／.mc-nav → 取不到；顏色一律在 .mcrec 上自己宣告（已踩過兩次的坑）。
   與模擬 v3 刻意不同處（照實測／Monk 決定）：輸出路由由使用者選（瀏覽器偵測不到耳機）；校準 16 聲約 10 秒；
   爆音保持 1.5 秒；錄影與成品都不鏡像；鏡頭只能在錄影前切換；音量用 dB（吉他 ≤ +12、伴奏 ≤ +7）。 */
(function(){
'use strict';
function boot(){
const R=window.MCJamRec, J=window.MCJam, entry=document.querySelector('[data-rec-open]');
if(!R||!J||!entry||document.querySelector('.mcrec')) return;
if(typeof MediaRecorder==='undefined'||!navigator.mediaDevices||!navigator.mediaDevices.getUserMedia||!HTMLCanvasElement.prototype.captureStream) return;
const {Env,Input,Meter,Calib,Recorder,Accomp,Align,Mixer,Output,ROUTE_NAMES}=R;
const {r1}=R.util;

/* ───────── 樣式 ───────── */
const CSS=`
.mcrec{--paper:#F7F4EC;--ink:#191816;--panel:#191816;--panel2:#24221E;--panel3:#2E2B26;--dline:#3A362F;
  --on:#F3EEE3;--dim:#A69E8E;--gold:#B28A2F;--gold2:#CFA851;
  --ok:#8CAA85;--okbg:#243022;--warn:#D9A95C;--warnbg:#3A301F;--bad:#E08D99;--badbg:#3E2329;--rec:#D2463F;
  position:fixed;left:0;top:0;right:0;bottom:0;z-index:2147483000;background:rgba(10,9,8,.72);
  font-family:'DM Sans','Noto Sans TC',-apple-system,"PingFang TC",sans-serif;font-size:15px;line-height:1.55;color:var(--on);
  -webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%}
.mcrec[hidden]{display:none!important}
.mcrec *{box-sizing:border-box}
.mcrec button,.mcrec select,.mcrec input{font-family:inherit;font-size:inherit;text-transform:none;letter-spacing:normal;margin:0}
.mcrec button{cursor:pointer;-webkit-tap-highlight-color:transparent}
.mcrec h3,.mcrec h4,.mcrec p{margin:0;text-transform:none;letter-spacing:normal;color:inherit}
.mcrec b{font-weight:700}
.mcrec [hidden]{display:none!important}
.mcrec button:focus-visible,.mcrec select:focus-visible,.mcrec input:focus-visible{outline:2px solid var(--gold2);outline-offset:2px}
.mcrec .ic{flex:none;display:block}
.mcrec-app{container-type:inline-size;position:absolute;left:0;top:0;right:0;bottom:0;background:var(--panel);overflow-y:auto;
  -webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding-bottom:calc(var(--mcrec-pb,0px) + env(safe-area-inset-bottom,0px))}
@media (min-width:760px){
  .mcrec-app{left:50%;top:20px;bottom:calc(20px + var(--mcrec-pb,0px));right:auto;padding-bottom:0;width:calc(100% - 40px);max-width:1180px;transform:translateX(-50%);border-radius:18px}
}
.mcrec .r-hd{display:flex;align-items:center;gap:10px;padding:14px 16px;padding-top:calc(14px + env(safe-area-inset-top,0px));border-bottom:1px solid var(--dline);
  position:sticky;top:0;background:var(--panel);z-index:2}
.mcrec .r-hd h3{flex:1;font-size:17px;font-weight:700;letter-spacing:-.2px}
.mcrec .r-step{font-size:12px;color:var(--dim);font-variant-numeric:tabular-nums}
.mcrec .r-ibtn{width:40px;height:40px;border-radius:12px;border:1px solid var(--dline);background:var(--panel2);color:var(--on);
  display:grid;place-items:center;padding:0}
.mcrec .r-bd{padding:16px;display:grid;gap:14px}
.mcrec .r-col{display:grid;gap:14px;align-content:start}
.mcrec .r-card{background:var(--panel2);border:1px solid var(--dline);border-radius:14px;padding:14px}
.mcrec .r-card-t{display:flex;align-items:center;gap:8px;font-size:12px;font-weight:700;letter-spacing:1.2px;color:var(--dim);margin:0 0 10px}
.mcrec .r-row{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
.mcrec .r-muted{color:var(--dim)} .mcrec .r-small{font-size:13px}
.mcrec .r-center{text-align:center}
.mcrec .r-sel{width:100%;background:var(--panel3);color:var(--on);border:1px solid var(--dline);border-radius:10px;padding:10px 12px;min-height:44px}
.mcrec .r-dseg{display:inline-flex;flex-wrap:wrap;gap:4px;background:var(--panel3);border:1px solid var(--dline);border-radius:10px;padding:3px}
.mcrec .r-dseg button{border:0;background:transparent;color:var(--dim);padding:7px 12px;border-radius:8px;font-size:13px;font-weight:600;min-height:38px;
  display:inline-flex;align-items:center;gap:6px}
.mcrec .r-dseg button[aria-pressed="true"]{background:var(--on);color:var(--panel)}
.mcrec .r-note{display:flex;gap:10px;align-items:flex-start;font-size:13px;line-height:1.5;border-radius:12px;padding:10px 12px}
.mcrec .r-note .ic{margin-top:1px}
.mcrec .r-note.r-info{background:var(--panel3);color:#d9d2c4}
.mcrec .r-note.r-warn{background:var(--warnbg);color:#f0d9ae}
.mcrec .r-note.r-bad{background:var(--badbg);color:#f3c9d0}
.mcrec .r-note.r-ok{background:var(--okbg);color:#cfe0cb}
.mcrec .r-sum{display:flex;justify-content:space-between;align-items:center;gap:10px}
.mcrec .r-sum b{font-size:15px}
.mcrec .r-link{background:none;border:0;color:var(--gold2);font-size:13px;padding:0;font-weight:600;white-space:nowrap}
/* 表頭 */
.mcrec .r-meter{display:grid;gap:8px}
.mcrec .r-m-top{display:flex;align-items:center;gap:10px}
.mcrec .r-lvl{font-size:13px;font-weight:700;padding:4px 10px;border-radius:999px}
.mcrec .r-lvl[data-s="low"]{background:var(--warnbg);color:var(--warn)}
.mcrec .r-lvl[data-s="ok"],.mcrec .r-lvl[data-s="hot"]{background:var(--okbg);color:var(--ok)}
.mcrec .r-lvl[data-s="clip"]{background:var(--badbg);color:var(--bad)}
.mcrec .r-lvl[data-s="idle"]{background:var(--panel3);color:var(--dim)}
.mcrec .r-db{font-weight:700;font-variant-numeric:tabular-nums;font-size:20px;letter-spacing:-.3px;min-width:78px;text-align:right;margin-left:auto}
.mcrec .r-db small{font-size:12px;color:var(--dim);font-weight:600;margin-left:2px}
.mcrec .r-clipled{font-size:11px;font-weight:700;letter-spacing:.8px;padding:3px 7px;border-radius:6px;border:1px solid var(--dline);color:#5d5850}
.mcrec .r-clipled[data-on="1"]{background:var(--rec);border-color:var(--rec);color:#fff}
.mcrec .r-m-bar{position:relative;height:18px;border-radius:6px;background:var(--panel3);overflow:hidden;border:1px solid var(--dline)}
.mcrec .r-m-zone{position:absolute;left:70%;width:20%;top:0;bottom:0;background:rgba(140,170,133,.14);border-left:1px dashed rgba(140,170,133,.55);border-right:1px dashed rgba(140,170,133,.55)}
.mcrec .r-m-fill{position:absolute;left:0;top:0;bottom:0;width:0;border-radius:5px 0 0 5px;background:linear-gradient(90deg,#6f8b69 0%,#8CAA85 70%,#D9A95C 90%,#E0636F 98%)}
.mcrec .r-m-scale{position:relative;height:14px;font-size:10px;color:var(--dim);font-variant-numeric:tabular-nums}
.mcrec .r-m-scale span{position:absolute;transform:translateX(-50%);white-space:nowrap}
.mcrec .r-m-scale span:first-child{transform:none}.mcrec .r-m-scale span:last-child{transform:translateX(-100%)}
.mcrec .r-tip{font-size:13px;color:#d9d2c4;min-height:40px}
.mcrec .r-meter.r-compact .r-m-bar{height:10px}
.mcrec .r-meter.r-compact .r-db{font-size:15px}
/* 按鈕 */
.mcrec .r-recbtn{display:flex;align-items:center;justify-content:center;gap:12px;width:100%;min-height:58px;border-radius:16px;border:0;
  background:var(--rec);color:#fff;font-weight:700;font-size:16px}
.mcrec .r-recbtn .r-dot{width:18px;height:18px;border-radius:50%;background:#fff;box-shadow:0 0 0 4px rgba(255,255,255,.25)}
.mcrec .r-recbtn:disabled{background:#4a4640;color:#9c958a;cursor:not-allowed}
.mcrec .r-recbtn:disabled .r-dot{background:#9c958a;box-shadow:none}
.mcrec .r-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;min-height:48px;padding:0 16px;border-radius:14px;
  border:1px solid var(--dline);background:var(--panel2);color:var(--on);font-weight:600;font-size:15px}
.mcrec .r-btn.r-gold{background:var(--gold);border-color:var(--gold);color:#191816}
.mcrec .r-btn.r-wide{width:100%}
.mcrec .r-btn:disabled{opacity:.45;cursor:not-allowed}
.mcrec .r-actions{display:grid;grid-template-columns:1fr 1.4fr;gap:10px}
/* 相機／鏡頭預覽（不鏡像） */
.mcrec video{display:block;width:100%;height:100%;object-fit:cover;background:#000}
.mcrec .r-thumb{position:relative;width:96px;aspect-ratio:9/16;border-radius:10px;overflow:hidden;background:#000;flex:none}
/* 校準 */
.mcrec .r-cal-ill{display:grid;place-items:center;padding:6px 0}
.mcrec .r-cal-steps{margin:0;padding-left:20px;display:grid;gap:6px;font-size:14px}
.mcrec .r-beats{display:flex;gap:6px;justify-content:center;flex-wrap:wrap}
.mcrec .r-beats i{width:12px;height:12px;border-radius:50%;background:var(--panel3);border:1px solid var(--dline);display:block}
.mcrec .r-beats i[data-on="1"]{background:var(--gold2);border-color:var(--gold2)}
.mcrec .r-big{font-size:44px;font-weight:700;letter-spacing:-1.2px;line-height:1;font-variant-numeric:tabular-nums}
.mcrec .r-big small{font-size:16px;color:var(--dim);margin-left:4px;letter-spacing:0}
.mcrec .r-prog{height:6px;border-radius:3px;background:var(--panel3);overflow:hidden}
.mcrec .r-prog i{display:block;height:100%;width:0;background:var(--gold2)}
/* 錄影中 */
.mcrec .r-rec-grid{position:relative;display:grid}
.mcrec .r-cam{position:relative;overflow:hidden;background:#000;width:100%;height:calc(100vh - var(--mcrec-pb,0px) - env(safe-area-inset-bottom,0px))}
@supports (height:100dvh){.mcrec .r-cam{height:calc(100dvh - var(--mcrec-pb,0px))}}
.mcrec .r-ov-top{position:absolute;left:0;right:0;top:0;display:flex;align-items:center;gap:10px;padding:14px;padding-top:calc(14px + env(safe-area-inset-top,0px));
  background:linear-gradient(180deg,rgba(0,0,0,.55),transparent)}
.mcrec .r-recdot{display:inline-flex;align-items:center;gap:7px;font-weight:700;font-size:14px;font-variant-numeric:tabular-nums;color:#fff}
.mcrec .r-recdot i{width:10px;height:10px;border-radius:50%;background:var(--rec);display:block;animation:mcrecblink 1s steps(2,start) infinite}
@keyframes mcrecblink{to{visibility:hidden}}
.mcrec .r-countdown{position:absolute;left:0;top:0;right:0;bottom:0;display:grid;place-items:center;text-align:center;background:rgba(0,0,0,.35);color:#fff}
.mcrec .r-countdown .r-n{font-size:120px;font-weight:700;line-height:1;letter-spacing:-4px;font-variant-numeric:tabular-nums}
.mcrec .r-countdown p{margin-top:6px;font-size:15px;color:#e9e2d4}
.mcrec .r-ov-bot{position:absolute;left:0;right:0;bottom:0;padding:14px;padding-bottom:calc(18px + env(safe-area-inset-bottom,0px));display:grid;gap:10px;
  background:linear-gradient(0deg,rgba(0,0,0,.72) 40%,transparent)}
.mcrec .r-pips{display:grid;gap:6px}
.mcrec .r-pips span{height:34px;border-radius:9px;background:rgba(36,34,30,.8);border:1px solid rgba(255,255,255,.12);
  display:grid;place-items:center;font-weight:700;font-size:14px;color:var(--dim);white-space:nowrap;overflow:hidden}
.mcrec .r-pips span[data-on="1"]{background:var(--on);color:var(--panel)}
.mcrec .r-stopbtn{width:64px;height:64px;border-radius:50%;border:3px solid #fff;background:transparent;display:grid;place-items:center;margin:0 auto;padding:0}
.mcrec .r-stopbtn .r-sq{width:24px;height:24px;border-radius:5px;background:var(--rec);display:block}
.mcrec .r-warnline{font-size:13px;text-align:center;font-weight:600}
.mcrec .r-side{display:none}
/* 預覽 */
/* 手機：影片高度上限 56vh、寬度跟著等比縮，音量與微調才不會全被擠到下面 */
.mcrec .r-player{position:relative;border-radius:14px;overflow:hidden;background:#000;aspect-ratio:9/16;margin:0 auto;width:100%;max-width:calc(56vh * 9 / 16)}
.mcrec .r-playbtn{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:66px;height:66px;border-radius:50%;
  border:0;background:rgba(243,238,227,.92);color:var(--panel);display:grid;place-items:center;padding:0}
.mcrec .r-playbtn[data-playing="1"]{opacity:0}
.mcrec .r-player:hover .r-playbtn[data-playing="1"]{opacity:.85}
.mcrec .r-scrub{display:grid;gap:4px;padding:10px 2px 0}
.mcrec .r-scrub .r-t{display:flex;justify-content:space-between;font-size:12px;color:var(--dim);font-variant-numeric:tabular-nums}
.mcrec input[type=range]{-webkit-appearance:auto;appearance:auto;width:100%;accent-color:var(--gold2);height:30px;background:transparent;margin:0;padding:0;border:0}
.mcrec .r-mix{display:grid;gap:12px}
.mcrec .r-mixrow{display:grid;grid-template-columns:72px 1fr 72px;gap:10px;align-items:center}
.mcrec .r-mixrow .r-nm{display:flex;align-items:center;gap:8px;font-weight:600}
.mcrec .r-mixrow .r-v{font-variant-numeric:tabular-nums;font-weight:700;text-align:right}
.mcrec .r-nudge{display:grid;grid-template-columns:auto 1fr auto;gap:8px;align-items:center}
.mcrec .r-nudge .r-ibtn{width:44px;height:44px;font-weight:700;font-size:15px}
.mcrec .r-nudgeval{text-align:center;font-weight:700;font-size:22px;font-variant-numeric:tabular-nums}
.mcrec .r-ticks{display:flex;justify-content:space-between;font-size:11px;color:var(--dim);padding:0 2px}
.mcrec .r-sheet{display:grid;gap:8px;background:var(--panel3);border:1px solid var(--dline);border-radius:14px;padding:12px}
.mcrec .r-sheet .r-ttl{font-size:12px;color:var(--dim);font-weight:700;letter-spacing:.8px}
.mcrec .r-sheet ul{margin:0;padding-left:18px;display:grid;gap:4px;font-size:13px;color:#d9d2c4}
.mcrec .r-modal{position:fixed;left:0;top:0;right:0;bottom:0;background:rgba(10,9,8,.72);display:grid;place-items:start center;padding:120px 20px 20px;z-index:5}
.mcrec .r-modal .r-box{background:var(--panel2);border:1px solid var(--dline);border-radius:18px;padding:20px;max-width:380px;width:100%;display:grid;gap:12px}
.mcrec .r-modal h4{font-size:18px;display:flex;gap:8px;align-items:center;color:var(--bad)}
.mcrec .r-modal p{font-size:14px;color:#d9d2c4}
.mcrec .r-only-d{display:none}
@container (min-width:760px){
  .mcrec .r-hd{padding:18px 24px}
  .mcrec .r-bd{padding:22px 24px;gap:18px}
  .mcrec .r-s1,.mcrec .r-s4{grid-template-columns:minmax(0,1fr) minmax(0,1fr);align-items:start}
  .mcrec .r-s4{grid-template-columns:minmax(0,1.3fr) minmax(0,1fr)}
  .mcrec .r-s2{max-width:600px;margin:0 auto;width:100%}
  .mcrec .r-rec-grid{grid-template-columns:minmax(0,2.1fr) minmax(0,1fr);gap:18px;align-items:start;padding:22px 24px}
  .mcrec .r-cam{height:auto;aspect-ratio:16/9;border-radius:14px}
  .mcrec .r-rec-grid .r-ov-bot{display:none}
  .mcrec .r-side{display:grid;gap:14px}
  .mcrec .r-side .r-timer{font-size:40px;font-weight:700;letter-spacing:-.8px;font-variant-numeric:tabular-nums;line-height:1}
  .mcrec .r-side .r-pips span{height:52px;font-size:18px}
  .mcrec .r-player{aspect-ratio:16/9;max-width:none}
  .mcrec .r-countdown .r-n{font-size:160px}
  .mcrec .r-only-m{display:none}
  .mcrec .r-only-d{display:block}
}
@media (prefers-reduced-motion:reduce){.mcrec .r-recdot i{animation:none}}
`;
const st=document.createElement('style'); st.textContent=CSS; document.head.appendChild(st);

/* ───────── 小工具 ───────── */
const IC={
  close:'<path d="M6 6l12 12M18 6L6 18"/>',back:'<path d="M15 18l-6-6 6-6"/>',
  mic:'<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/>',
  usb:'<path d="M12 21V5M8 8l4-4 4 4"/><path d="M12 15l-4-2V10M12 13l4-2V8"/>',
  headphones:'<path d="M4 15v-3a8 8 0 0 1 16 0v3"/><rect x="3" y="14" width="4" height="7" rx="1.5"/><rect x="17" y="14" width="4" height="7" rx="1.5"/>',
  speaker:'<path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/>',
  target:'<circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="2.5"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/>',
  info:'<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5"/>',
  warn:'<path d="M12 3.5l9.5 17h-19z"/><path d="M12 10v4.5M12 17.5v.5"/>',
  check:'<path d="M5 12.5l4.5 4.5L19 7"/>',
  play:'<path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/>',
  pause:'<path d="M7 5h3v14H7zM14 5h3v14h-3z" fill="currentColor" stroke="none"/>',
  retake:'<path d="M4 12a8 8 0 1 0 2.3-5.6"/><path d="M4 4v4h4"/>',
  save:'<path d="M12 4v11M7 10l5 5 5-5"/><path d="M5 19h14"/>',
  flip:'<path d="M4 8h13l-3-3M20 16H7l3 3"/>',
  sliders:'<path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>',
  guitar:'<path d="M14 10l6-6M18 2l4 4"/><path d="M11.5 8.5a4 4 0 0 0-5.3 1.2 3 3 0 0 1-2.6 1.6 3.5 3.5 0 0 0-.6 6.9 3.5 3.5 0 0 0 6.9-.6 3 3 0 0 1 1.6-2.6 4 4 0 0 0 1.2-5.3"/><circle cx="9" cy="15" r="1.2"/>',
  music:'<path d="M9 18V6l10-2v12"/><circle cx="6.5" cy="18" r="2.5"/><circle cx="16.5" cy="16" r="2.5"/>',
  camera:'<path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>'
};
const ic=(n,s)=>'<svg class="ic" viewBox="0 0 24 24" width="'+(s||20)+'" height="'+(s||20)+'" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+IC[n]+'</svg>';
const esc=t=>String(t).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const fmtT=s=>{ s=Math.max(0,s); return Math.floor(s/60)+':'+String(Math.floor(s%60)).padStart(2,'0'); };
const fmtDb=v=>(v>0?'+':v<0?'−':'')+Math.abs(v).toFixed(1)+' dB';
const fmtMs=v=>(v>0?'+':v<0?'−':'')+Math.abs(v)+' ms';
/* 音量：畫面用 dB，模組用 % 平方曲線（gain＝(v/100)²＝10^(dB/20) → v＝100·10^(dB/40)） */
const dbToPct=d=>100*Math.pow(10,d/40);
const pctToDb=v=>v<=0?-24:Math.round(40*Math.log10(v/100)*2)/2;
const GAIN={guitar:{min:-24,max:12},accomp:{min:-24,max:7}};
const STYLE_NAMES={rock:'Rock',pop:'Pop',ballad:'Ballad',shuffle:'Shuffle'};
const OUT_ICON={wired:'headphones',speaker:'speaker',interface:'usb'};
const routeName=r=>Env.mobile?ROUTE_NAMES[r]:({interface:'錄音介面的耳機孔',speaker:'電腦喇叭'}[r]||ROUTE_NAMES[r]);
const store={ get(k,d){ try{ const v=localStorage.getItem('mcjam-rec:'+k); return v===null?d:JSON.parse(v); }catch(e){ return d; } },
              set(k,v){ try{ localStorage.setItem('mcjam-rec:'+k,JSON.stringify(v)); }catch(e){} } };
const TIPS={
  low:{phone:'聲音太小：手機靠近音箱或吉他一點，或把音箱音量開大。',usb:'聲音太小：把介面上這一軌的 GAIN 旋鈕往右轉。'},
  ok:{phone:'音量剛好。彈最大聲的段落時，偶爾碰到黃色沒關係。',usb:'音量剛好。彈最大聲的段落時，偶爾碰到黃色沒關係。'},
  clip:{phone:'爆音了，錄下來會破音而且救不回來：手機離音箱遠一點，或把音箱轉小聲。',usb:'爆音了，錄下來會破音而且救不回來：把介面上這一軌的 GAIN 旋鈕往左轉。'}
};
const MIXTIPS={low:'混音偏小：吉他和伴奏可以一起調大一點。',ok:'混音音量剛好，存出來的影片不會破音。',clip:'混音爆音了，存出來的影片會破音：把吉他或伴奏調小，或按下面的「自動降到不爆音」。',idle:'按播放時會顯示即時音量。'};

/* ───────── 事件（GA4，Monk 2026-09-16 定 7 個動作）─────────
   實際送出在 sections/mc-tool-analytics.liquid 的 window.mcToolTrack（GA4 ID 與 analyzelyDataLayer 寫法只住那裡）。
   rec_open／rec_start／rec_complete／rec_export／rec_save_share／rec_save_download／rec_fail(fail_reason)。不送 Meta、不標關鍵事件。 */
const track=(action,params)=>{ try{ if(typeof window.mcToolTrack==='function') window.mcToolTrack(action,params); }catch(e){} };

/* ───────── 狀態 ───────── */
const U={open:false,screen:'setup',inp:null,inpErr:null,opening:false,meter:new Meter(),
  route:store.get('route',Env.routes[0]),channel:store.get('channel',0),deviceId:store.get('deviceId',''),facing:'user',inputs:[],
  calRun:'idle',calP:0,calRes:null,
  recH:null,recStopping:false,take:null,al:null,mixer:null,proc:'',procErr:null,
  prev:null,pos:0,gDb:0,aDb:pctToDb(Mixer.CONFIG.defaultAccomp),uiNudge:0,peak:null,
  exp:'idle',expP:0,expErr:null,out:null,saved:false,saveRes:null,confirm:false};
if(Env.routes.indexOf(U.route)<0) U.route=Env.routes[0];

const ov=document.createElement('div');
ov.className='mcrec'; ov.hidden=true; ov.setAttribute('translate','no');
ov.setAttribute('role','dialog'); ov.setAttribute('aria-modal','true'); ov.setAttribute('aria-label','Jam Loop 錄影');
ov.innerHTML='<div class="mcrec-app" data-app></div>';
document.body.appendChild(ov);
const app=ov.querySelector('[data-app]');
const $=s=>app.querySelector(s), $$=s=>app.querySelectorAll(s);
/* 影片元素只建一次、每次繪製時搬進新容器（重建會斷掉相機串流） */
const camVid=document.createElement('video'); camVid.muted=true; camVid.playsInline=true; camVid.setAttribute('playsinline',''); camVid.autoplay=true;
const prevVid=document.createElement('video'); prevVid.muted=true; prevVid.playsInline=true; prevVid.setAttribute('playsinline','');

entry.hidden=false;
entry.addEventListener('click',()=>openUI());

/* ───────── 開關 ───────── */
/* 只在預覽開發主題時出現的 Shopify 預覽列（#PBarNextFrameWrapper）會蓋住浮層底部的按鈕（Monk iPhone 實測）→
   量它的實際高度當底部留白；預覽列可收合所以持續重量。正式上線訪客沒有這條 → 值為 0，不影響版面。 */
function barPad(){
  const w=document.getElementById('PBarNextFrameWrapper'); if(!w) return 0;
  const r=w.getBoundingClientRect(); return (r.height>0&&r.top<innerHeight)?Math.ceil(innerHeight-r.top):0;
}
let lastPad=-1, padT=0;
function applyBarPad(){ const p=barPad(); if(p!==lastPad){ lastPad=p; ov.style.setProperty('--mcrec-pb',p+'px'); } }
let htmlOverflow='';
function openUI(){
  if(U.open) return;
  U.open=true; ov.hidden=false; applyBarPad(); htmlOverflow=document.documentElement.style.overflow; document.documentElement.style.overflow='hidden';
  J.stop();
  U.screen='setup'; render();
  track('rec_open',{rec_support:Env.support});
  if(Env.support!=='blocked') openInput();
  loop();
}
/* 被打斷後 iOS 可能已停掉相機／麥克風串流 → 回到設定畫面時要重開 */
function inputAlive(){ return !!(U.inp&&U.inp.stream.getTracks().every(t=>t.readyState==='live')); }
document.addEventListener('visibilitychange',()=>{ if(U.open&&!document.hidden&&U.screen==='setup'&&!U.opening&&U.inp&&!inputAlive()) openInput(); });
function unsavedTake(){ return !!(U.take&&!U.take.failed&&!U.saved); }
function closeUI(force){
  if(!force){
    if(U.recH&&!confirm('正在錄影，確定要結束並離開？')) return;
    if(!U.recH&&unsavedTake()&&!confirm('影片還沒存，離開就會不見。確定離開？')) return;
  }
  const finish=()=>{
    stopPreview(); if(U.mixer){ U.mixer.release(); U.mixer=null; }
    U.take=null; U.al=null; U.out=null; U.exp='idle'; U.saved=false;
    if(U.inp){ U.inp.close(); U.inp=null; }
    camVid.srcObject=null; prevVid.removeAttribute('src'); prevVid.load();
    J.lock(false);
    U.open=false; ov.hidden=true; document.documentElement.style.overflow=htmlOverflow;
  };
  if(U.recH){ const h=U.recH; U.recH=null; h.stop().then(finish); } else finish();
}
async function openInput(){
  if(U.opening) return;
  U.opening=true; U.inpErr=null;
  if(U.inp){ U.inp.close(); U.inp=null; }
  if(U.screen==='setup') render();
  try{
    U.inp=await Input.open({videoEl:camVid,deviceId:U.deviceId||undefined,channel:U.channel,facingMode:U.facing});
    U.inp.onPeak=v=>U.meter.push(v);
    U.meter.reset();
    if(!Env.mobile){ U.inputs=await Input.listInputs(); }
  }catch(e){
    const nm=e&&e.name;
    U.inpErr=nm==='NotAllowedError'?'denied':nm==='NotFoundError'?'notfound':(nm==='NotReadableError'||nm==='AbortError')?'inuse':(e&&e.message)||String(e);
    /* 記住的輸入裝置可能已拔掉 → 清掉再試一次預設裝置 */
    if(U.deviceId&&U.inpErr!=='denied'){ U.deviceId=''; store.set('deviceId',''); U.opening=false; return openInput(); }
    track('rec_fail',{fail_reason:'input_'+(['denied','notfound','inuse'].indexOf(U.inpErr)>=0?U.inpErr:'other')});
  }
  U.opening=false;
  if(U.open&&U.screen==='setup') render();
}

/* ───────── 共用片段 ───────── */
function meterHTML(src,compact){
  return '<div class="r-meter'+(compact?' r-compact':'')+'" data-meter="'+src+'">'+
    '<div class="r-m-top"><span class="r-lvl" data-lvl data-s="idle">—</span><span class="r-clipled" data-clip data-on="0">CLIP</span>'+
    '<span class="r-db" data-db>—<small>dB</small></span></div>'+
    '<div class="r-m-bar" role="meter" aria-label="'+(src==='mix'?'混音輸出音量':'輸入音量')+'" aria-valuemin="-60" aria-valuemax="0"><div class="r-m-zone"></div><i class="r-m-fill" data-fill></i></div>'+
    (compact?'':'<div class="r-m-scale"><span style="left:0">−60</span><span style="left:40%">−36</span><span style="left:70%">−18</span><span style="left:90%">−6</span><span style="left:100%">0</span></div><p class="r-tip" data-tip></p>')+
  '</div>';
}
function paintMeter(el,s,tipText){
  if(!el) return;
  const pct=Math.max(0,Math.min(100,(s.db+60)/60*100));
  el.querySelector('[data-fill]').style.width=pct+'%';
  const lv=el.querySelector('[data-lvl]'), z=s.zone==='hot'?'ok':s.zone;
  if(lv.dataset.s!==s.zone){ lv.dataset.s=s.zone; lv.textContent=s.text; }
  el.querySelector('[data-db]').innerHTML=(s.db<=-119?'—':r1(s.db))+'<small>dB</small>';
  el.querySelector('[data-clip]').dataset.on=s.clip?'1':'0';
  const tip=el.querySelector('[data-tip]'); if(tip&&tipText!==undefined){ const t=tipText(z); if(tip.textContent!==t) tip.textContent=t; }
}
const inTip=z=>(TIPS[z]||TIPS.ok)[U.route==='interface'?'usb':'phone'];
function calInfo(){ return Calib.get(U.route,U.inp?U.inp.label:''); }
function note(kind,icon,html){ return '<div class="r-note r-'+kind+'">'+ic(icon,18)+'<span>'+html+'</span></div>'; }
function bind(sel,ev,fn){ $$(sel).forEach(el=>el.addEventListener(ev,fn)); }

/* ───────── 畫面 1：錄影設定 ───────── */
function sSetup(){
  const hd='<div class="r-hd"><h3>錄影設定</h3><span class="r-step">1 / 3</span><button class="r-ibtn" data-close aria-label="關閉">'+ic('close',18)+'</button></div>';
  if(Env.support==='blocked'){
    return hd+'<div class="r-bd">'+note('bad','warn','<b>'+esc(Env.reason)+'</b>。這個瀏覽器錄音會越錄越偏，錄出來的吉他會跟伴奏對不上。')+
      '<button class="r-btn r-wide" data-close>回到 Jam Loop</button></div>';
  }
  const snap=J.snapshot();
  const summary=esc((snap.labels||[]).join(' – '))+'<br><span class="r-small r-muted">'+snap.bpm+' BPM · '+(STYLE_NAMES[snap.style]||snap.style)+' · '+snap.meter+'/4 · '+snap.bars+' 小節</span>';
  let inputCard;
  if(U.inpErr){
    const msg=U.inpErr==='denied'?'沒有拿到相機或麥克風的權限。請在瀏覽器設定允許這個網站使用相機與麥克風，再按「重試」。'+(Env.inApp?'在 IG／微信裡如果沒跳出詢問，可以點右上角「⋯」→「在外部瀏覽器開啟」。':'')
      :U.inpErr==='notfound'?'找不到相機或麥克風。'
      :U.inpErr==='inuse'?'相機或麥克風正被其他 App 使用（例如視訊通話、相機），請先關掉再按「重試」。'
      :'無法開啟相機與麥克風（'+esc(U.inpErr)+'）。';
    inputCard='<div class="r-card"><p class="r-card-t">'+ic('mic',16)+'相機與麥克風</p>'+note('bad','warn',msg)+'<button class="r-btn r-wide" style="margin-top:10px" data-retry>重試</button></div>';
  }else if(!U.inp){
    inputCard='<div class="r-card"><p class="r-card-t">'+ic('mic',16)+'相機與麥克風</p><p class="r-small r-muted">開啟中…（第一次會詢問權限，請按「允許」）</p></div>';
  }else{
    const dev=Env.mobile?'<span class="r-small">'+esc(U.inp.label||'手機麥克風')+'</span>':
      '<select class="r-sel" data-dev aria-label="輸入裝置">'+U.inputs.map(d=>'<option value="'+esc(d.id)+'"'+(d.id===U.inp.deviceId?' selected':'')+'>'+esc(d.label)+'</option>').join('')+'</select>';
    const chan=U.inp.channels>=2?'<div class="r-row" style="margin-top:10px"><span class="r-small r-muted">錄哪一軌</span><div class="r-dseg" data-chan>'+
      [0,1].map(c=>'<button data-v="'+c+'" aria-pressed="'+(U.inp.channel===c)+'">CH '+(c+1)+'</button>').join('')+'</div><span class="r-small r-muted">吉他插在哪一軌就選哪一軌</span></div>':'';
    const proc=U.inp.proc.off===false?note('bad','warn','瀏覽器沒有關掉語音處理（回音消除／降噪），錄樂器的時間會不準。建議換用 Safari 或 Chrome。'):'';
    inputCard='<div class="r-card"><p class="r-card-t">'+ic(U.route==='interface'?'usb':'mic',16)+'輸入</p>'+
      '<div class="r-row" style="flex-wrap:nowrap;align-items:flex-start"><div class="r-thumb">'+'<span data-camslot></span>'+'</div>'+
      '<div style="display:grid;gap:8px;flex:1;min-width:0">'+dev+
      (Env.mobile?'<button class="r-btn" data-flip>'+ic('flip',18)+(U.facing==='user'?'換後鏡頭':'換前鏡頭')+'</button><span class="r-small r-muted">鏡頭只能在開始錄影前切換</span>':'')+
      '</div></div>'+chan+(proc?'<div style="margin-top:10px">'+proc+'</div>':'')+'</div>';
  }
  const routeSeg='<div class="r-dseg" data-route>'+Env.routes.map(r=>'<button data-v="'+r+'" aria-pressed="'+(r===U.route)+'">'+ic(OUT_ICON[r],16)+esc(routeName(r))+'</button>').join('')+'</div>';
  let outNote='';
  if(U.route==='speaker'&&Env.mobile) outNote=note('warn','info','用喇叭外放時，伴奏會一起被麥克風收進去；錄完把伴奏調小，吉他軌裡還是會聽到一點伴奏。戴有線耳機效果最好。');
  else if(U.route==='speaker') outNote=note('warn','warn','電腦喇叭加內建麥克風的延遲很不穩，必須先做精準校準；量不穩的話就沒辦法錄，請改接錄音介面。');
  const c=calInfo();
  let calRow;
  if(c.source==='measured') calRow=note('ok','check','已校準 <b>'+c.ms+' ms</b>（記在「'+esc(routeName(U.route))+'」）');
  else if(c.ms!=null) calRow=note('info','info','使用預設值 <b>'+c.ms+' ms</b>（iPhone '+esc(routeName(U.route))+'）。錄完如果覺得吉他拖拍或搶拍，可以微調，或先做一次精準校準。');
  else calRow=note('warn','warn','這個輸出方式沒有預設值，<b>要先做精準校準才能錄</b>。');
  const canRec=!!(U.inp&&U.inp.camReady&&c.ms!=null);
  const recSub=!U.inp?'等相機與麥克風開好':c.ms==null?'先做精準校準才能錄':'倒數 1 小節後開始 · 最長 3 分鐘';
  const modal=U.confirm?'<div class="r-modal" role="dialog" aria-modal="true" aria-label="爆音確認"><div class="r-box">'+
      '<h4>'+ic('warn',20)+'目前會破音</h4><p>剛剛的輸入音量有爆音，錄下來會破音，事後調小也救不回來。</p>'+
      '<p class="r-small r-muted">'+esc(inTip('clip').replace('爆音了，錄下來會破音而且救不回來：','建議：'))+'</p>'+
      '<div class="r-actions"><button class="r-btn" data-confirm="go">仍要錄</button><button class="r-btn r-gold" data-confirm="fix">先去調整</button></div></div></div>':'';
  const unver=Env.support==='unverified'?note('warn','warn',esc(Env.reason)+'。'):'';
  return modal+hd+'<div class="r-bd r-s1">'+
    '<div class="r-col">'+unver+
      '<div class="r-card"><div class="r-sum"><div><div class="r-small r-muted">伴奏</div><b>'+summary+'</b></div><button class="r-link" data-editjam>改伴奏</button></div></div>'+
      inputCard+
      '<div class="r-card"><p class="r-card-t">'+ic(OUT_ICON[U.route],16)+'聲音從哪裡出來</p>'+routeSeg+
        '<p class="r-small r-muted" style="margin-top:8px">不支援藍牙耳機（延遲大而且每次不同，錄出來會對不準）。</p>'+(outNote?'<div style="margin-top:10px">'+outNote+'</div>':'')+'</div>'+
      note('info','headphones','錄的時候耳機<b>不會</b>播出你的吉他聲（網頁會慢約 0.07 秒，彈起來很怪）。請用'+(U.route==='interface'?'介面的直接監聽':'音箱或木吉他的原聲')+'。')+
    '</div>'+
    '<div class="r-col">'+
      '<div class="r-card"><p class="r-card-t">'+ic('sliders',16)+'輸入音量 · 先彈一段最大聲的</p>'+meterHTML('in',false)+'</div>'+
      '<div class="r-card"><p class="r-card-t">'+ic('target',16)+'同步校準</p>'+calRow+
        '<button class="r-btn r-wide" style="margin-top:10px" data-gocal '+(U.inp?'':'disabled')+'>'+ic('target',18)+'精準校準（約 10 秒）</button></div>'+
      '<button class="r-recbtn" data-rec '+(canRec?'':'disabled')+'><span class="r-dot"></span>開始錄影</button>'+
      '<p class="r-small r-muted r-center">'+recSub+'</p>'+
    '</div></div>';
}
function bindSetup(){
  bind('[data-close]','click',()=>closeUI());
  bind('[data-retry]','click',()=>openInput());
  bind('[data-editjam]','click',()=>{ closeUI(); const p=document.querySelector('[data-jam]'); if(p) p.scrollIntoView({behavior:'smooth',block:'start'}); });
  bind('[data-dev]','change',e=>{ U.deviceId=e.target.value; store.set('deviceId',U.deviceId); openInput(); });
  bind('[data-flip]','click',()=>{ U.facing=U.facing==='user'?'environment':'user'; openInput(); });
  $$('[data-chan] button').forEach(b=>b.addEventListener('click',()=>{ U.channel=+b.dataset.v; store.set('channel',U.channel); if(U.inp) U.inp.setChannel(U.channel); U.meter.reset(); render(); }));
  $$('[data-route] button').forEach(b=>b.addEventListener('click',()=>{ U.route=b.dataset.v; store.set('route',U.route); render(); }));
  bind('[data-gocal]','click',()=>{ U.calRun='idle'; U.calRes=null; U.screen='cal'; render(); });
  bind('[data-rec]','click',()=>{ if(U.meter.clippedWithin(Meter.CONFIG.holdMs)){ U.confirm=true; render(); return; } startRec(); });
  bind('[data-confirm]','click',e=>{ const go=e.currentTarget.dataset.confirm==='go'; U.confirm=false; if(go) startRec(); else render(); });
  const slot=$('[data-camslot]'); if(slot){ slot.replaceWith(camVid); camVid.play().catch(()=>{}); }
}

/* ───────── 畫面 2：精準校準 ───────── */
const CAL_BEATS=16;
function sCal(){
  const r=U.route, name=routeName(r);
  const steps=r==='interface'?['打開介面的 LOOPBACK，或用一條導線把介面的輸出接回輸入。','拔掉樂器導線，GAIN 旋鈕轉到中間。','按「開始」，會播 16 下節拍聲。']
    :r==='speaker'?[Env.mobile?'手機平放，音量開到約 70%。':'電腦音量開到約 70%。','周圍保持安靜，吉他先別彈。','按「開始」，會播 16 下節拍聲。']
    :['把<b>一邊耳塞貼住手機底部的麥克風孔</b>。','周圍保持安靜，吉他先別彈。','按「開始」，會播 16 下節拍聲。'];
  const ill=r==='interface'
    ?'<svg width="220" height="110" viewBox="0 0 220 110" aria-hidden="true"><rect x="40" y="30" width="140" height="50" rx="10" fill="none" stroke="#A69E8E" stroke-width="2"/><circle cx="75" cy="55" r="9" fill="none" stroke="#CFA851" stroke-width="2"/><circle cx="145" cy="55" r="9" fill="none" stroke="#CFA851" stroke-width="2"/><path d="M75 64 C75 105, 145 105, 145 64" fill="none" stroke="#CFA851" stroke-width="3" stroke-dasharray="6 5"/><text x="75" y="22" fill="#A69E8E" font-size="11" text-anchor="middle">輸出</text><text x="145" y="22" fill="#A69E8E" font-size="11" text-anchor="middle">輸入</text></svg>'
    :r==='speaker'
    ?'<svg width="220" height="110" viewBox="0 0 220 110" aria-hidden="true"><rect x="60" y="45" width="100" height="44" rx="10" fill="none" stroke="#A69E8E" stroke-width="2"/><path d="M40 67h10M170 67h10" stroke="#CFA851" stroke-width="2"/><path d="M110 30 q10 -12 20 0 M100 22 q20 -20 40 0" fill="none" stroke="#CFA851" stroke-width="2"/></svg>'
    :'<svg width="220" height="120" viewBox="0 0 220 120" aria-hidden="true"><rect x="80" y="8" width="60" height="108" rx="12" fill="none" stroke="#A69E8E" stroke-width="2"/><circle cx="110" cy="106" r="3" fill="#A69E8E"/><path d="M170 30 C200 40, 190 90, 130 100" fill="none" stroke="#A69E8E" stroke-width="2"/><ellipse cx="124" cy="102" rx="9" ry="7" fill="#CFA851"/><path d="M146 102 q8 -6 0 -12 M152 106 q14 -12 0 -24" fill="none" stroke="#CFA851" stroke-width="2"/></svg>';
  const res=U.calRes, running=U.calRun==='running';
  const lit=running?Math.floor(U.calP*CAL_BEATS):res?(res.detected||0):0;
  const dots='<div class="r-beats" data-beats>'+Array.from({length:CAL_BEATS},(_,i)=>'<i data-on="'+(i<lit?1:0)+'"></i>').join('')+'</div>';
  let body;
  if(U.calRun==='ok'){
    body='<div class="r-card r-center" style="display:grid;gap:8px"><div class="r-small r-muted">量到的延遲</div><div class="r-big">'+res.ms+'<small>ms</small></div>'+dots+
      '<div class="r-small r-muted">'+res.detected+' / '+res.beats+' 聲一致 · 記在「'+esc(name)+'」底下</div>'+
      '<div style="text-align:left">'+note('info','info',Env.mobile?'換成別的耳機或改用喇叭時，延遲不一樣，需要另外校準一次。':'換成別的介面或改用電腦喇叭時，延遲不一樣，需要另外校準一次。')+'</div></div>'+
      '<div class="r-actions"><button class="r-btn" data-calgo>'+ic('retake',18)+'重測</button><button class="r-btn r-gold" data-caluse>'+ic('check',18)+'使用這個值</button></div>';
  }else if(U.calRun==='fail'){
    const def=Calib.get(U.route,U.inp?U.inp.label:'');
    body='<div class="r-card r-center" style="display:grid;gap:8px"><div class="r-small r-muted">結果</div><div class="r-big" style="font-size:30px">量不準</div>'+dots+
      '<div style="text-align:left">'+note('warn','warn',esc(res&&res.reason||'量測失敗')+(r==='interface'?'。確認 LOOPBACK 有打開、GAIN 不要轉到最小。':''))+'</div></div>'+
      '<div class="r-actions">'+(def.ms!=null?'<button class="r-btn" data-caluse>'+(def.source==='measured'?'沿用之前的值':'改用預設值')+'</button>':'<button class="r-btn" data-calback>返回</button>')+
      '<button class="r-btn r-gold" data-calgo>'+ic('retake',18)+'再試一次</button></div>';
  }else{
    body='<div class="r-card" style="display:grid;gap:14px"><div class="r-cal-ill">'+ill+'</div><ol class="r-cal-steps">'+steps.map(s=>'<li>'+s+'</li>').join('')+'</ol></div>'+
      '<div class="r-card r-center" style="display:grid;gap:10px">'+dots+'<div class="r-small r-muted" data-calmsg>'+(running?'量測中，請保持安靜…':'準備好了就開始')+'</div></div>'+
      '<button class="r-btn r-gold r-wide" data-calgo '+(running?'disabled':'')+'>'+ic('target',18)+(running?'量測中':'開始')+'</button>';
  }
  return '<div class="r-hd"><button class="r-ibtn" data-calback aria-label="返回" '+(running?'disabled':'')+'>'+ic('back',18)+'</button><h3>精準校準</h3><span class="r-step">'+esc(name)+'</span></div><div class="r-bd r-s2">'+body+'</div>';
}
function bindCal(){
  bind('[data-calback]','click',()=>{ if(U.calRun==='running') return; U.screen='setup'; render(); });
  bind('[data-caluse]','click',()=>{ U.screen='setup'; render(); });
  bind('[data-calgo]','click',async()=>{
    if(!U.inp||U.calRun==='running') return;
    U.calRun='running'; U.calP=0; U.calRes=null; render();
    try{ U.calRes=await Calib.measure(U.inp,U.route,{beats:CAL_BEATS,onProgress:p=>{ U.calP=p; }}); U.calRun=U.calRes.ok?'ok':'fail'; }
    catch(e){ U.calRes={reason:(e&&e.message)||String(e),detected:0,beats:CAL_BEATS}; U.calRun='fail'; }
    if(U.calRun==='fail') track('rec_fail',{fail_reason:'calibration'});
    if(U.screen==='cal') render();
  });
}

/* ───────── 畫面 3：錄影中 ───────── */
function pipsHTML(labels,cols){ return '<div class="r-pips" data-pips style="grid-template-columns:repeat('+cols+',minmax(0,1fr))">'+labels.map((l,i)=>'<span data-i="'+i+'">'+esc(l)+'</span>').join('')+'</div>'; }
function sRec(){
  const h=U.recH, labels=(h&&h.snap.labels)||[], cols=Math.min(labels.length||4,6);
  return '<div class="r-rec-grid">'+
    '<div class="r-cam"><span data-camslot></span>'+
      '<div class="r-ov-top"><span class="r-recdot" data-rtop>準備</span></div>'+
      '<div class="r-countdown" data-count><div><div class="r-n" data-countn>—</div><p>倒數 1 小節 · 伴奏開始後就在錄了</p></div></div>'+
      '<div class="r-ov-bot">'+pipsHTML(labels,cols)+meterHTML('rec',true)+'<div class="r-warnline" data-rwarn></div>'+
        '<button class="r-stopbtn" data-stop aria-label="停止錄影"><span class="r-sq"></span></button></div>'+
    '</div>'+
    '<div class="r-side">'+
      '<div class="r-card"><div class="r-small r-muted" data-sstate>準備開始</div><div class="r-row" style="margin-top:6px"><span class="r-timer" data-stimer>—</span><span class="r-muted r-small">/ 3:00</span></div></div>'+
      '<div class="r-card"><p class="r-card-t">'+ic('music',16)+'和弦進行 · <span data-sbar>—</span></p>'+pipsHTML(labels,cols)+'</div>'+
      '<div class="r-card"><p class="r-card-t">'+ic('sliders',16)+'輸入音量</p>'+meterHTML('rec2',true)+'<div class="r-warnline" data-rwarn style="margin-top:8px"></div></div>'+
      '<button class="r-recbtn" style="background:var(--panel2);border:1px solid var(--dline)" data-stop><span style="width:16px;height:16px;border-radius:3px;background:var(--rec);display:block"></span>停止錄影</button>'+
      '<p class="r-small r-muted r-center">剩最後 15 秒時會提醒，時間到自動停止</p>'+
    '</div></div>';
}
function bindRec(){
  const slot=$('[data-camslot]'); if(slot){ slot.replaceWith(camVid); camVid.play().catch(()=>{}); }
  bind('[data-stop]','click',()=>stopRec());
}
async function startRec(){
  if(!U.inp) return;
  stopPreview(); if(U.mixer){ U.mixer.release(); U.mixer=null; }
  U.take=null; U.al=null; U.out=null; U.exp='idle'; U.expErr=null; U.saved=false; U.saveRes=null; U.procErr=null;
  try{
    U.recH=await Recorder.start(U.inp,{onAutoStop:t=>afterRec(t),onInterrupt:info=>{
      /* 立刻離開錄影畫面：真正的停止要等回到前景才做得完 */
      U.interrupting=info; U.screen='review'; U.take=null; U.al=null; U.mixer=null; U.proc='錄影被中斷，處理中…'; render();
    }});
    lastTick=0;   /* 進錄影畫面重置，等第一輪跑完才開始判斷凍結 */
    U.screen='rec'; render();
    track('rec_start',{rec_route:U.route,cal_source:calInfo().source||'none'});
  }catch(e){ U.recH=null; track('rec_fail',{fail_reason:'start'}); alert('無法開始錄影：'+((e&&e.message)||e)); render(); }
}
async function stopRec(){
  if(!U.recH||U.recStopping) return;
  U.recStopping=true;
  const t=await U.recH.stop();
  afterRec(t);
}
async function afterRec(t){
  if(!U.recH) return;
  U.recH=null; U.recStopping=false; U.interrupting=null;
  U.take=t; U.screen='review'; U.proc='對齊中…'; U.al=null; render();
  if(t.failed){ U.proc=''; track('rec_fail',{fail_reason:t.failed}); render(); return; }
  try{
    const cal=calInfo();
    /* 先量影片起點（解碼整支音軌很吃記憶體）再重算伴奏，避免 3 分鐘時疊加 */
    const vo=await Align.videoOffset(t);
    U.proc='重算伴奏…'; updProc();
    const acc=await Accomp.render(t,0.1);
    t.ref=null;
    U.al=Align.build(t,cal.ms,vo); U.al.calSource=cal.source;
    U.mixer=new Mixer(t,acc,U.al);
    t.mic=null;
    U.gDb=0; U.aDb=pctToDb(Mixer.CONFIG.defaultAccomp); U.uiNudge=0; U.pos=0;
    applyGains(); U.peak=U.mixer.peak();
    U.proc='';
    track('rec_complete',{rec_seconds:Math.round(U.al.lenSec),rec_interrupted:t.interrupted?1:0,rec_auto_stopped:t.autoStopped?1:0});
  }catch(e){ U.procErr=(e&&e.message)||String(e); U.proc=''; track('rec_fail',{fail_reason:'process'}); }
  if(U.open&&U.screen==='review') render();
}
function updProc(){ const el=$('[data-proc]'); if(el) el.textContent=U.proc; }

/* ───────── 畫面 4：錄後預覽 ───────── */
/* 只在網址加 ?debug=1 時顯示的中斷診斷（給實機回報用） */
const DEBUG=/[?&]debug=1/.test(location.search);
function diagNote(t){
  if(!DEBUG||!t||!t.diag) return '';
  const d=t.diag;
  return note('info','info','診斷：cause='+esc(String(d.cause))+' · 中斷於 '+d.intrAtSec+'s · 收音到 '+d.micEndSec+'s · 音訊時鐘 '+d.ctxNowSec+
    's · 背景 '+d.bgSec+'s · ctx '+esc(String(d.ctxAtIntr))+'→'+esc(String(d.ctxNow))+' · 長度 '+t.lenSec+'s · failed='+esc(String(t.failed)));
}
function sReview(){
  const t=U.take;
  const hd='<div class="r-hd"><button class="r-ibtn" data-again aria-label="重錄">'+ic('back',18)+'</button><h3>錄後預覽</h3><span class="r-step">'+(t?fmtT(t.lenSec):'')+'</span></div>';
  if(t&&t.failed){
    return hd+'<div class="r-bd">'+note('bad','warn',esc(Recorder.FAIL_TEXT[t.failed]||'錄影失敗'))+diagNote(t)+'<button class="r-recbtn" data-again><span class="r-dot"></span>再錄一次</button></div>';
  }
  if(U.procErr) return hd+'<div class="r-bd">'+note('bad','warn','處理錄音時出錯：'+esc(U.procErr))+'<button class="r-recbtn" data-again><span class="r-dot"></span>再錄一次</button></div>';
  if(U.proc||!U.mixer) return hd+'<div class="r-bd"><div class="r-card r-center" style="display:grid;gap:10px;padding:32px 14px"><b data-proc>'+esc(U.proc||'處理中…')+'</b><span class="r-small r-muted">3 分鐘的錄影大約要 10 秒</span></div></div>';
  const m=U.mixer, len=m.lenSec, playing=!!U.prev;
  const alignNote=(t.interrupted?note('warn','warn','錄影在 '+fmtT(t.interrupted.atSec)+' 被中斷（切換 App、鎖螢幕或來電），只保留中斷前的部分。'):'')+
    (t.autoStopped?note('info','info','已錄滿 3 分鐘，自動停止。'):'')+diagNote(t)+
    note('ok','check','已自動對齊（補償 '+r1(U.al.rtMs)+' ms · '+(U.al.calSource==='measured'?'精準校準':'預設值')+'）')+
    (U.al.dFallback?note('warn','info','畫面和聲音的起點沒量準，可能差一點點，存之前看一下預覽。'):'');
  let expo;
  if(U.exp==='run'){
    expo='<div class="r-card" style="display:grid;gap:8px"><div class="r-row" style="justify-content:space-between"><b>合成影片中…</b><span data-expp>'+Math.round(U.expP*100)+'%</span></div>'+
      '<div class="r-prog"><i data-expbar style="width:'+(U.expP*100)+'%"></i></div>'+
      '<div class="r-small r-muted">約需 '+fmtT(len)+'（和錄影長度差不多）。請停留在這個畫面，'+(Env.mobile?'不要切換 App 或鎖螢幕':'不要切到別的分頁')+'。</div></div>';
  }else if(U.exp==='done'){
    const sr=U.saveRes;
    let result='';
    if(sr==='done') result=note('ok','check',Env.mobile?'已完成。存到照片的話，可以打開照片 App 查看。':'已存好。');
    else if(sr==='neutral') result=note('info','info','如果已經存好，就可以關閉這個畫面。還沒存到的話，再按一次「'+(Env.mobile?'儲存或分享':'儲存影片…')+'」。');
    else if(sr==='unsupported') result=note('warn','info',esc(Output.TEXT.unsupported));
    else if(sr==='error') result=note('bad','warn',esc(Output.TEXT.error));
    else if(sr==='download') result=note('info','info',Env.browser==='WeChat'?'微信會先開啟預覽：點「用其他應用開啟」→「儲存到檔案」。':Env.mobile?'會存到「檔案」App 的下載項目。':'已開始下載。');
    const canShare=Output.canShareFile(U.out);
    expo=note('ok','check','影片合成完成（'+fmtT(len)+' · '+r1(U.out.size/1e6)+' MB）。')+
      '<div class="r-only-m"><div style="display:grid;gap:10px">'+
        (canShare?'<button class="r-btn r-gold r-wide" data-rshare>'+ic('save',18)+'儲存或分享</button><p class="r-small r-muted r-center">會跳出分享選單：選「儲存影片」存到照片，或直接分享到 IG</p>'
          :note('warn','info',esc(Output.TEXT.unsupported)))+
        result+
        '<p class="r-small r-center"><button class="r-link" data-dl>下載影片檔</button><span class="r-muted"> · '+(Env.browser==='WeChat'?'微信要多按「用其他應用開啟」':'存到「檔案」App')+'</span></p>'+
        '<button class="r-btn r-wide" data-again>'+ic('retake',18)+'再錄一次</button>'+
      '</div></div>'+
      '<div class="r-only-d"><div style="display:grid;gap:10px">'+
        '<div class="r-sheet"><span class="r-ttl">按下後會跳出另存新檔視窗</span><ul><li>自己選資料夾和檔名，預設檔名 <b>'+esc(Output.fileName(U.out))+'</b></li><li>影片只存在你的電腦，不會上傳</li></ul></div>'+
        result+
        '<div class="r-actions"><button class="r-btn" data-again>'+ic('retake',18)+'再錄一次</button><button class="r-btn r-gold" data-saveas>'+ic('save',18)+'儲存影片…</button></div>'+
      '</div></div>';
  }else{
    expo=(U.expErr?note('bad','warn',esc(U.expErr)):'')+
      '<div class="r-actions"><button class="r-btn" data-again>'+ic('retake',18)+'重錄</button><button class="r-btn r-gold" data-export>'+ic('save',18)+'存成影片</button></div>';
  }
  const busy=U.exp==='run';
  return hd+'<div class="r-bd r-s4">'+
    '<div class="r-col"><div><div class="r-player"><span data-prevslot></span>'+
      '<button class="r-playbtn" data-rplay data-playing="'+(playing?1:0)+'" aria-label="'+(playing?'停止':'播放')+'" '+(busy?'disabled':'')+'>'+ic(playing?'pause':'play',26)+'</button></div>'+
      '<div class="r-scrub"><input type="range" min="0" max="'+Math.floor(len*10)+'" value="'+Math.round(U.pos*10)+'" data-scrub aria-label="播放位置" '+(busy?'disabled':'')+'>'+
      '<div class="r-t"><span data-tpos>'+fmtT(U.pos)+'</span><span>'+fmtT(len)+'</span></div></div></div></div>'+
    '<div class="r-col">'+alignNote+
      '<div class="r-card r-mix"><p class="r-card-t">'+ic('sliders',16)+'音量平衡</p>'+
        '<div class="r-mixrow"><span class="r-nm">'+ic('guitar',18)+'吉他</span><input type="range" min="'+GAIN.guitar.min+'" max="'+GAIN.guitar.max+'" step="0.5" value="'+U.gDb+'" data-gain="guitar" aria-label="吉他音量" '+(busy?'disabled':'')+'><span class="r-v" data-gv>'+fmtDb(U.gDb)+'</span></div>'+
        '<div class="r-mixrow"><span class="r-nm">'+ic('music',18)+'伴奏</span><input type="range" min="'+GAIN.accomp.min+'" max="'+GAIN.accomp.max+'" step="0.5" value="'+U.aDb+'" data-gain="accomp" aria-label="伴奏音量" '+(busy?'disabled':'')+'><span class="r-v" data-av>'+fmtDb(U.aDb)+'</span></div>'+
        '<div class="r-small r-muted">伴奏裡鼓、貝斯、和弦的比例沿用 Jam Loop 上的設定。</div>'+
        meterHTML('mix',false)+
        '<button class="r-btn r-wide" data-autofit hidden '+(busy?'disabled':'')+'>自動降到不爆音</button>'+
      '</div>'+
      '<div class="r-card"><p class="r-card-t">'+ic('target',16)+'同步微調</p>'+
        '<div class="r-nudgeval" data-nv>'+fmtMs(U.uiNudge)+'</div>'+
        '<div class="r-nudge"><button class="r-ibtn" data-nd="-1" aria-label="吉他提前 1 毫秒" '+(busy?'disabled':'')+'>−1</button>'+
          '<input type="range" min="-50" max="50" step="1" value="'+U.uiNudge+'" data-nudge aria-label="同步微調" '+(busy?'disabled':'')+'>'+
          '<button class="r-ibtn" data-nd="1" aria-label="吉他延後 1 毫秒" '+(busy?'disabled':'')+'>+1</button></div>'+
        '<div class="r-ticks"><span>−50 吉他提前</span><span>0</span><span>吉他延後 +50</span></div>'+
        '<div class="r-small r-muted" style="margin-top:6px">吉他聽起來拖拍往 −，搶拍往 +。差很多、調到底都對不上的話，可能是用了藍牙耳機（不支援），請改用有線耳機重錄。</div>'+
      '</div>'+expo+
    '</div></div>';
}
function applyGains(){ if(!U.mixer) return; U.mixer.guitar=dbToPct(U.gDb); U.mixer.accomp=dbToPct(U.aDb); U.mixer.setNudge(-U.uiNudge); }
let peakT=0;
function mixChanged(restart){
  applyGains();
  if(U.exp==='done'){ U.exp='idle'; U.out=null; U.saveRes=null; render(); }   /* 設定改了，存好的影片已經不是現在聽到的 → 要重新合成 */
  if(U.prev){ if(restart){ const at=U.prev.position(); stopPreview(); startPreview(at); } else U.prev.setGains(); }
  clearTimeout(peakT); peakT=setTimeout(()=>{ if(U.mixer){ U.peak=U.mixer.peak(); paintPeak(); } },200);
}
function paintPeak(){
  const b=$('[data-autofit]'); if(b) b.hidden=!(U.peak&&U.peak.clip);
  if(!U.prev&&U.peak){
    const d=U.peak.db, zone=d>=Meter.CONFIG.clip?'clip':d<Meter.CONFIG.low?'low':'ok';
    paintMeter($('[data-meter="mix"]'),{db:d,zone,clip:zone==='clip',text:{low:'太小',ok:'剛好',clip:'爆音'}[zone]},z=>MIXTIPS[z]+'（整支最大 '+r1(d)+' dB）');
  }
}
async function startPreview(at){
  if(!U.mixer) return;
  try{
    U.prev=await U.mixer.preview(prevVid,at||0);
    const b=$('[data-rplay]'); if(b){ b.dataset.playing='1'; b.innerHTML=ic('pause',26); b.setAttribute('aria-label','停止'); }
  }catch(e){ U.prev=null; alert('預覽失敗：'+((e&&e.message)||e)); }
}
function stopPreview(){
  if(!U.prev) return;
  U.pos=U.prev.position(); if(U.pos>=U.mixer.lenSec-0.3) U.pos=0;
  U.prev.stop(); U.prev=null;
  const b=$('[data-rplay]'); if(b){ b.dataset.playing='0'; b.innerHTML=ic('play',26); b.setAttribute('aria-label','播放'); }
  paintPeak();
}
function bindReview(){
  bind('[data-again]','click',()=>{
    if(U.exp==='run') return;
    if(unsavedTake()&&U.mixer&&!confirm('這支還沒存，重錄就會不見。確定重錄？')) return;
    stopPreview(); if(U.mixer){ U.mixer.release(); U.mixer=null; }
    U.take=null; U.al=null; U.out=null; U.exp='idle'; U.saved=false; U.saveRes=null; U.procErr=null;
    prevVid.removeAttribute('src'); prevVid.load();
    U.screen='setup'; render();
    if(!inputAlive()) openInput();
  });
  const slot=$('[data-prevslot]');
  if(slot&&U.mixer){
    slot.replaceWith(prevVid);
    if(!prevVid.src){ prevVid.src=URL.createObjectURL(U.take.blob); prevVid.addEventListener('loadedmetadata',()=>{ try{ prevVid.currentTime=Math.max(0,U.al.fileStart); }catch(e){} },{once:true}); }
    U.mixer._url=prevVid.src;
  }
  bind('[data-rplay]','click',()=>{ if(U.prev) stopPreview(); else startPreview(U.pos); });
  bind('[data-scrub]','input',e=>{ U.pos=+e.target.value/10; const tp=$('[data-tpos]'); if(tp) tp.textContent=fmtT(U.pos); });
  bind('[data-scrub]','change',e=>{ U.pos=+e.target.value/10; if(U.prev){ stopPreview(); startPreview(U.pos); } else { try{ prevVid.currentTime=U.al.fileStart+U.pos; }catch(_){} } });
  $$('[data-gain]').forEach(el=>el.addEventListener('input',()=>{
    const k=el.dataset.gain, v=+el.value;
    if(k==='guitar'){ U.gDb=v; $('[data-gv]').textContent=fmtDb(v); } else { U.aDb=v; $('[data-av]').textContent=fmtDb(v); }
    mixChanged(false);
  }));
  const setN=v=>{ U.uiNudge=Math.max(-50,Math.min(50,Math.round(v))); $('[data-nv]').textContent=fmtMs(U.uiNudge); const r=$('[data-nudge]'); if(r) r.value=U.uiNudge; };
  bind('[data-nudge]','input',e=>setN(+e.target.value));
  bind('[data-nudge]','change',()=>mixChanged(true));
  $$('[data-nd]').forEach(b=>b.addEventListener('click',()=>{ setN(U.uiNudge+(+b.dataset.nd)); mixChanged(true); }));
  bind('[data-autofit]','click',()=>{
    const r=U.mixer.autoFit(); if(!r.changed) return;
    U.gDb=Math.max(GAIN.guitar.min,pctToDb(U.mixer.guitar)); U.aDb=Math.max(GAIN.accomp.min,pctToDb(U.mixer.accomp));
    /* pctToDb 取 0.5dB 格可能往上捨入 → 以滑桿值重新套回並確認不爆 */
    applyGains(); let p=U.mixer.peak();
    for(let i=0;i<8&&p.clip;i++){ U.gDb-=0.5; U.aDb-=0.5; applyGains(); p=U.mixer.peak(); }
    U.peak=p; if(U.exp==='done'){ U.exp='idle'; U.out=null; U.saveRes=null; }
    if(U.prev) U.prev.setGains();
    render();
  });
  bind('[data-export]','click',async()=>{
    if(!U.mixer||U.exp==='run') return;
    stopPreview();
    U.exp='run'; U.expP=0; U.expErr=null; render();
    try{
      const res=await Output.compose(U.mixer,{onProgress:p=>{ U.expP=p; }});
      U.out=res.blob; U.exp='done'; U.saveRes=null; U.saved=false;
      track('rec_export',{rec_seconds:Math.round(U.mixer.lenSec)});
    }catch(e){
      U.exp='idle';
      track('rec_fail',{fail_reason:e&&e.code==='hidden'?'export_interrupted':'export'});
      U.expErr=e&&e.code==='hidden'?'合成時離開了畫面，影片沒存好。請停留在這個畫面，再按一次「存成影片」。':'合成失敗（'+((e&&e.message)||e)+'），請再試一次。';
    }
    if(U.open&&U.screen==='review') render();
  });
  bind('[data-rshare]','click',async()=>{
    if(!U.out) return;
    const r=await Output.share(U.out);
    U.saveRes=r.result; if(r.result==='done'||r.result==='neutral') U.saved=true;
    if(r.result==='done'||r.result==='neutral') track('rec_save_share',{save_result:r.result});
    else track('rec_fail',{fail_reason:'save_'+r.result});
    render();
  });
  bind('[data-saveas]','click',async()=>{
    if(!U.out) return;
    let r=await Output.saveAs(U.out);
    if(r.result==='unsupported'){ Output.download(U.out); r={result:'download'}; }
    U.saveRes=r.result; if(r.result==='done'||r.result==='download') U.saved=true;
    if(r.result==='done') track('rec_save_download',{save_method:'save_as'});
    else if(r.result==='download') track('rec_save_download',{save_method:'download'});
    else if(r.result==='error') track('rec_fail',{fail_reason:'save_error'});
    render();
  });
  bind('[data-dl]','click',()=>{ if(!U.out) return; Output.download(U.out); U.saveRes='download'; U.saved=true; track('rec_save_download',{save_method:'download'}); render(); });
  paintPeak();
}

/* ───────── 繪製與即時更新 ───────── */
function render(){
  const y=app.scrollTop;
  app.innerHTML=U.screen==='cal'?sCal():U.screen==='rec'?sRec():U.screen==='review'?sReview():sSetup();
  ({cal:bindCal,rec:bindRec,review:bindReview}[U.screen]||bindSetup)();
  if(U.screen!=='rec') app.scrollTop=y;
}
let lastTick=0;
function loop(){
  if(!U.open) return;
  requestAnimationFrame(loop);
  const now=performance.now(), s=U.meter.state(now);
  if(now-padT>500){ padT=now; applyBarPad(); }
  if(U.screen==='setup') paintMeter($('[data-meter="in"]'),s,inTip);
  else if(U.screen==='cal'&&U.calRun==='running'){
    const lit=Math.floor(U.calP*CAL_BEATS);
    $$('[data-beats] i').forEach((el,i)=>{ el.dataset.on=i<lit?'1':'0'; });
  }else if(U.screen==='rec'&&U.recH){
    /* 畫面更新中斷 >2 秒＝被凍結（鎖螢幕時 iOS 不一定發 visibilitychange）→ 當成中斷 */
    if(lastTick&&now-lastTick>2000&&!U.recH.interrupted()) U.recH.interrupt('frozen');
    const h=U.recH, el=h.elapsed(), beat=h.sps*(h.spb/h.snap.meter), barDur=h.sps*h.spb;
    const counting=el<0;
    const cd=$('[data-count]'); if(cd) cd.hidden=!counting;
    if(counting){ const n=$('[data-countn]'); if(n) n.textContent=String(Math.max(1,Math.ceil(-el/beat))); }
    const top=$('[data-rtop]'); if(top) top.innerHTML=counting?'準備':'<i></i>'+fmtT(el)+' / 3:00';
    const stt=$('[data-sstate]'); if(stt) stt.textContent=counting?'準備開始':'錄影中';
    const stm=$('[data-stimer]'); if(stm) stm.textContent=counting?String(Math.max(1,Math.ceil(-el/beat))):fmtT(el);
    const bar=counting?-1:Math.floor(el/barDur)%h.snap.bars;
    const sb=$('[data-sbar]'); if(sb) sb.textContent=counting?'—':'第 '+(bar+1)+' 小節';
    $$('[data-pips] span').forEach(sp=>{ sp.dataset.on=(+sp.dataset.i===bar)?'1':'0'; });
    paintMeter($('[data-meter="rec"]'),s); paintMeter($('[data-meter="rec2"]'),s);
    const left=h.maxSec-el;
    /* 爆音與剩餘時間兩個提醒可能同時成立 → 兩行都顯示，別互相蓋掉 */
    const warn=(s.clip?'<div style="color:var(--bad)">爆音中，這段錄音會破音</div>':'')+((!counting&&left<=15)?'<div style="color:var(--warn)">剩 '+Math.ceil(Math.max(0,left))+' 秒，時間到會自動停止</div>':'');
    $$('[data-rwarn]').forEach(w=>{ if(w.innerHTML!==warn) w.innerHTML=warn; });
  }else if(U.screen==='review'){
    if(U.prev){
      if(U.prev.ended()){ stopPreview(); U.pos=0; }
      else{
        paintMeter($('[data-meter="mix"]'),U.prev.graph.readMeter(),z=>MIXTIPS[z]);
        const p=U.prev.position(), sc=$('[data-scrub]'), tp=$('[data-tpos]');
        if(sc&&document.activeElement!==sc) sc.value=Math.round(p*10);
        if(tp) tp.textContent=fmtT(p);
      }
    }
    if(U.exp==='run'){
      const e1=$('[data-expp]'), e2=$('[data-expbar]');
      if(e1) e1.textContent=Math.round(U.expP*100)+'%'; if(e2) e2.style.width=(U.expP*100)+'%';
    }
  }
  lastTick=now;   /* 每一輪都要更新：只在錄影分支更新的話，一進錄影畫面就會拿舊值誤判成凍結 */
}
window.addEventListener('pagehide',()=>{ if(U.open) closeUI(true); });
/* 開發用檢查掛勾：只在 ?debug=1 時掛上，正式訪客頁面不留全域變數 */
if(DEBUG) window.__jamrecUI={state:U,open:openUI,close:closeUI};
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
